function attach_alternative_course(sender, courseId) {
    const $ = jQuery.noConflict();

    const alternativeId = parseInt($(sender).find('select').val());

    $('body').isLoading();
    $.post(`/courses/${courseId}/setAlternative/${alternativeId}`).always(() => {
        $('body').doneLoading();
        reload_location_if_needed(false);
    });

    return false;
}
function detach_alternative_course(alternativeId, courseId) {
    const $ = jQuery.noConflict();

    $('body').isLoading();
    $.post(`/courses/${courseId}/unsetAlternative/${alternativeId}`).always(() => {
        $('body').doneLoading();
        reload_location_if_needed(false);
    });

    return false;
}